import type { ReactNode } from 'react';

interface Props {
  title: string;
  description?: string;
  /**
   * Wenn `false` oder `0`/leeres Array, rendert die Section nichts.
   * So bleibt die Panel-Oberfläche ruhig und kontextuell.
   */
  visible: boolean;
  children: ReactNode;
}

/**
 * Standard-Container für eine Section im Debug-Panel.
 * Leere Sections werden konsequent ausgeblendet (Akzeptanzkriterium 7).
 */
export function DebugSection({ title, description, visible, children }: Props) {
  if (!visible) return null;
  return (
    <section className="px-4 py-4 border-b border-border/60 last:border-b-0">
      <header className="mb-2">
        <h3 className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
          {title}
        </h3>
        {description ? (
          <p className="text-xs text-muted-foreground/80 mt-0.5">{description}</p>
        ) : null}
      </header>
      <div className="space-y-2">{children}</div>
    </section>
  );
}
